import { render } from "./Face.vue?vue&type=template&id=9736bd9a&scoped=true"
import script from "./Face.vue?vue&type=script&lang=js"
export * from "./Face.vue?vue&type=script&lang=js"

import "./Face.vue?vue&type=style&index=0&id=9736bd9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9736bd9a"]])

export default __exports__